import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-cream-100 font-sans antialiased" data-id="element-0" data-mp="31agput0v2nlk">
      <UrgencyBar data-id="element-1" data-mp="31cjpm4rtfv3h" />
      <Hero data-id="element-2" data-mp="2wk9y4kb1ymz3" />
      <main data-id="element-3" data-mp="2wjqgz5t882m4">
        <HookSection data-id="element-4" data-mp="2wiyuqllirh8i" />
        <PainSection data-id="element-5" data-mp="2wip5j08ate3v" />
        <RevelationSection data-id="element-6" data-mp="2wi5mfg6wwjo9" />
        <OfferSection data-id="element-7" data-mp="28tw44o8wqe1v" />
        <PricingSection data-id="element-8" data-mp="28t4mkhc5agul" />
        <FaqSection data-id="element-9" data-mp="28skzynbjv4a8" />
        <GuaranteeSection data-id="element-10" data-mp="23vcjcr61v8b3" />
      </main>
      <Footer data-id="element-11" data-mp="23u9u0nodldxa" />
    </div>;
}